<template>
    <LayoutBase>
        <div class="full-height grid">
            <account-sidebar></account-sidebar>

            <div id="content-wrapper" class="app-position">
                <div class="container-fluid">
                    <div class="row no-gutters">
                        <div class="col-md-2"></div>
                        <div class="col-md-8">
                            <div class="article-wrapper">
                                <div class="panel">
                                    <header>
                                        <h1>Login Page</h1>
                                    </header>

                                    <div class="form">
                                        <div class="form__group">
                                            <label class="form__label" for="login_title">Page Title</label>
                                            <input type="text" id="login_title" name="login_title" class="form__control" v-model="account.login_title">
                                        </div>

                                        <div class="form__group">
                                            <label class="form__label" for="login_short_intro">Short Intro</label>
                                            <textarea id="login_short_intro" name="login_short_intro" class="form__control" v-model="account.login_short_intro"></textarea>
                                        </div>

                                        <div class="form__group">
                                            <button class="btn btn-primary" v-on:click.stop.prevent="saveSettings">Save Changes</button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                </div>
            </div>
        </div>
    </LayoutBase>
</template>

<script>
    import LayoutBase from '../../layouts/LayoutBase';

    export default {
        components: {
            LayoutBase
        },
        data () {
            return {
                account: {
                    name : null,
                    logo: null
                },
            }
        },
        mounted() {
            this.getUsers();
        },
        methods: {
            getUsers() {
                axios.get('/api/account/').then((response) => {
                    this.account = response.data;
                }, (response) => {
                    this.error = response;
                });
            },
            saveSettings(){
                axios.put('/api/account/login', this.account).then((response) => {
                    this.account = response.data;
                    this.$store.commit('auth/setTeam', response.data);
                }, (response) => {
                    this.error = response;
                });
            }
        },
        // Guard to protect route from none admins
        beforeRouteEnter(to, from, next){
            if (!window.user_can.admin) next('/')
            else next()
        }
    }
</script>
